import React from 'react';
import PropTypes from 'prop-types';
import Picture from '@deporvillage/picture-component';
import { Config } from '@deporvillage/utils-library-component';

import styles from './Mosaic.module.scss';

const Mosaic = ({ items, onClick }) => {
    const { origin, isMobile } = React.useContext(Config);
    const handleOnClickBanner = (position) => onClick && onClick(position);

    return items?.length && (
        <div className={styles['home-page-mosaic']}>
            {
                items.map(({
                    position, name, url, image,
                }, idx) => (
                    <a
                        key={position}
                        data-testid='mosaic-home-anchor'
                        title={name}
                        onClick={() => handleOnClickBanner(position)}
                        href={`${origin}/${url.split('/').pop()}`}>
                        <Picture
                            className={styles.picture}
                            src={image}
                            sizes={{
                                360: '160x200',
                                500: '336x423',
                                767: '354x423',
                                1034: '750x482',
                                1399: '238x300',
                            }}
                            height={416}
                            width={330}
                            lazy={(isMobile && idx > 1) || (!isMobile && idx > 3)}
                            crop
                        />
                        <span className={styles.title}>{name}</span>
                    </a>
                ))
            }
        </div>
    );
};
Mosaic.propTypes = {
    items: PropTypes.arrayOf(
        PropTypes.shape({
            image: PropTypes.string,
            name: PropTypes.string,
            position: PropTypes.number,
            url: PropTypes.string,
        }),
    ),
    onClick: PropTypes.func,
};

export default Mosaic;
